import { Get } from 'src/axios';
import { TContact } from 'src/types/contacts';

const getContacts = () => Get<TContact[]>('/staticpages/contacts/');

export { getContacts };
